"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpBadStatusCodeError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
var HttpBadStatusCodeError = /** @class */ (function (_super) {
    tslib_1.__extends(HttpBadStatusCodeError, _super);
    function HttpBadStatusCodeError(params, _statusCode, _domain) {
        var _this = this;
        var message;
        var domain;
        var details;
        if (typeof params === 'string') {
            message = params;
            domain = _domain;
        }
        else {
            message = params.message;
            domain = params.domain;
            details = params.details;
        }
        _this = _super.call(this, { type: 'BadStatusCodeError', domain: domain || 'unknown-domain.by-peperrors', message: message, details: details }) || this;
        if (typeof params === 'string') {
            _this.statusCode = _statusCode;
        }
        else {
            _this.statusCode = params.statusCode;
        }
        Object.setPrototypeOf(_this, HttpBadStatusCodeError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpBadStatusCodeError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return HttpBadStatusCodeError;
}(genericError_js_1.GenericError));
exports.HttpBadStatusCodeError = HttpBadStatusCodeError;
//# sourceMappingURL=httpBadStatusCodeError.js.map